import PropTypes from "prop-types";

import PriceIndexInfo from "./price-index-info";
import PriceGraphic from "./price-graphic";

const DistrictReportPriceIndex = ({
  listingData,
  districtReportPriceInfos,
  listingTradeTypeValue,
  listingEstateType,
  isProjectPage,
  unitTypes,
}) => {
  return (
    <div>
      {!isProjectPage && (
        <PriceIndexInfo districtReportPriceInfos={districtReportPriceInfos} listingEstateType={listingEstateType} />
      )}
      <PriceGraphic
        districtReportPriceInfos={districtReportPriceInfos}
        listingTradeTypeValue={listingTradeTypeValue}
        listingEstateTypeValue={listingEstateType}
        listingData={listingData}
        isProjectPage={isProjectPage}
        unitTypes={unitTypes}
      />
    </div>
  );
};

DistrictReportPriceIndex.propTypes = {
  listingData: PropTypes.object,
  districtReportDemographicInfos: PropTypes.object,
  districtReportPriceInfos: PropTypes.object,
  listingTradeTypeValue: PropTypes.string,
  listingEstateType: PropTypes.string,
  isProjectPage: PropTypes.bool,
  unitTypes: PropTypes.array,
};
export default DistrictReportPriceIndex;
